// extracted by mini-css-extract-plugin
export default {"root":"EditSection_root__V1fDT","title":"EditSection_title__7mmCv","editButton":"EditSection_editButton__y2ma6"};